import { Stack, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import AddressBlock from 'shared/components/AddressBlock';
import TvaNumber from 'shared/components/TvaNumber';

import type { InvoiceFormSharedProps } from '../InvoiceForm.types';

type CompanyDetailsProps = InvoiceFormSharedProps;

export const CompanyDetails = ({ company }: CompanyDetailsProps) => {
  const { t } = useTranslation();

  const { name, address_attributes, vat_number } = company;

  return (
    <Stack gap={0}>
      <Text fw="bold">{name}</Text>
      <AddressBlock address={address_attributes} />
      <Text mt="md">
        {t(i18nKeys.VAT)} : <TvaNumber value={vat_number} />
      </Text>
    </Stack>
  );
};
